export default __webpack_public_path__ + "static/media/ventrilla1.49009ed5.jpg";